import { serializable } from 'serializr';
import { observable, makeObservable } from 'mobx';
import { IApiPlayWithBallFinals } from 'interfaces/session/IApiPlayWithBallFinals';
import { IPlayer } from 'interfaces/team/IPlayer';
import type { IApiSessionMetadataUpdated } from 'interfaces/tagging/ApiModels/IApiSessionMetadataUpdated';

export class ReviewGame {
  constructor() {
    this.sessionId = '';
    this.taggedOn = '';
    this.field = '';
    this.plays = [] as IApiPlayWithBallFinals[];
    this.homeTeamPlayers = [];
    this.awayTeamPlayers = [];
    this.sessionMetadata = {} as IApiSessionMetadataUpdated;
    this.gameReference = '';
    makeObservable(this);
  }

  @serializable
  @observable
  public field: string;

  @serializable
  @observable
  public sessionId: string;

  @serializable
  @observable
  public taggedOn: string;

  @serializable
  @observable
  public gameReference: string | undefined;

  @serializable
  @observable
  public plays: IApiPlayWithBallFinals[];

  @observable
  public homeTeamPlayers: IPlayer[];

  @observable
  public awayTeamPlayers: IPlayer[];

  @observable
  public sessionMetadata: IApiSessionMetadataUpdated;
}
